import { saFaq } from './sa-faq';

window.app.controller('applicationCtrl', ['$scope', '$mdDialog', function ($scope, $mdDialog) {

  $scope.showAuth = false;
  $scope.verificationIsGoing = false;
  $scope.failVerification = false;
  $scope.applicationPartners = '';
  $scope.woormyInfo = {};
  $scope.sendAtOnce;

  $scope.offerStatusError = false;
  $scope.offerStatusIsSet = true;
  $scope.applicationSent = false;
  $scope.showCongratsOnAppSent = false;
  $scope.applicatiOnopened = false;
  $scope.partners;
  $scope.verificationStatus = false;
  $scope.availableOffers = true;
  $scope.firstEntry = false;
  $scope.businessKey;
  // $scope.paramChanged = false;
  $scope.costVal;
  $scope.durationVal;
  $scope.faqs = saFaq;

  $scope.user = {
    costVal: +(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500),
    durationVal: +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30),
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    pesel: "",
    socialNumber: "",
    persId2ExpiryDate: "",
    bankAccount: "",
    bankName: "",
    livPostcode: "",
    livCity: "",
    livStreet: "",
    livBuilding: "",
    livApartment: "",
    livStatus: "",
    livRegion: "",
    incomeSource: "",
    monthlyIncome: "",
    monthlyExpenses: "",
    incomeDay: "",
    agreement: "",
    empName: "",
    nip: "",
    universityCity: "",
    universityName: "",
    occupation: "",
    educationStatus: "",
    maritalStatus: "",
    dependentsNumber: "",
    car: "",
    empPhone: "",
    experience: "",
    empType: "",
    incomeStudSource: "",
    empRegion: "",
    acceptTerms: "",
    acceptAdPolicy: "",
    acceptMailingPolicy: "",
  };

  $scope.allSAOffers = [];
  $scope.alternativeOffers = [
    {
      logo: "5bf7bf462a533016276954d6",
      title: "Halocredit",
      minAmount: "200",
      maxAmount: "3000",
      minTerm: "5",
      maxTerm: "31",
      termUnit: "dni",
      link: "/stats/outclick/?offerId=5bf7c0a22a533016276954d9"
    },
    {
      logo: "5d4195eb124f8d6b36748952",
      title: "FINZMO",
      minAmount: "1000",
      maxAmount: "25000",
      minTerm: "3",
      maxTerm: "48",
      termUnit: "miesięcy",
      link: "/stats/outclick/?offerId=5d419c34124f8d6c3c43ae92"
    }
  ];

  $scope.slideFaq = () => {
    $(this).find()
  };

  $scope.slideForm = function () {
    $(event.target).toggleClass('open').next('.sa-form-wrapper').slideToggle();
  };

  $("#passExpireDate").datepicker({ dateFormat: 'dd/mm/yy', changeYear: true, minDate: 0 });
  $("#passExpireDatePr").datepicker({ dateFormat: 'dd/mm/yy', changeYear: true, minDate: 0 });

  $scope.sameVerifDataMessage = () => {
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup">
          <p class="title text-center">Dane Twoich pól (imię, nazwisko, numer rachunku bankowego) nie
          uległy zmianie. Kontynuować weryfikację?</p>
          <div class="layout" layout-align="space-between">
              <button class="action-btn" ng-click="loadWoormy()" aria-label="yes">Tak</button>
              <button class="action-btn" ng-click="closeDialog()" aria-label="no">Nie</button>
          </div>
      </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    });
  }

  $scope.hasWoormyInfoChanged = () => {
    if ($scope.woormyInfo.firstName === $scope.user.firstName &&
      $scope.woormyInfo.lastName === $scope.user.lastName &&
      $scope.woormyInfo.account === $scope.user.bankAccount &&
      $scope.woormyInfo.user_identification === $scope.user.pesel) {
      return false;
    } else { return true }
  }

  $scope.verificate = (partners, key) => {
    $('#saFormBody').slideUp();
    $scope.partners = partners;
    if (!$scope.hasWoormyInfoChanged()) {
      $scope.sameVerifDataMessage();
    } else {
      $scope.getBusinessKey(key)
    }
  }

  $scope.loadWoormy = () => {
    $scope.woormyInfo = {
      firstName: $scope.user.firstName,
      lastName: $scope.user.lastName,
      account: $scope.user.bankAccount,
      user_identification: $scope.user.pesel
    };

    $scope.verificationIsGoing = true;

    const woor = new Woormy();

    woor['userParam']('source', 'racoongo.com');
    woor['userParam']('environment', 'test');
    woor['userParam']('businessKey', $scope.businessKey);
    woor['userParam']('firstName', "Justyna");
    woor['userParam']('lastName', "Papizh");
    woor['userParam']('account', "92124049371111001084441200");
    woor['userParam']('user_identification', "66051357188");

    // woor['userParam']('source', 'racoongo.com');
    // woor['userParam']('environment', 'test');
    // woor['userParam']('businessKey', $scope.businessKey);
    // woor['userParam']('firstName', $scope.user.firstName);
    // woor['userParam']('lastName', $scope.user.lastName);
    // woor['userParam']('account', $scope.user.bankAccount);
    // woor['userParam']('user_identification', $scope.user.pesel);

    woor.getWoormy();

    woor.listener(res => {
      switch (res) {
        case 'PROCESS-FINISHED': {
          $scope.verificationIsGoing = true;
          // $scope.failVerification = false;
          $scope.submitFormWithVerif();
          break;
        }
        case 'WRONG_CREDENTIALS': {
          $scope.verificationIsGoing = false;
          // $scope.failVerification = true;
          break;
        }
        case 'SERVICE_ERROR': {
          $scope.verificationIsGoing = false;
          // $scope.failVerification = false;
          break;
        }
      }
    });

    // woor.workListener(isWorks => {
    //     if(!isWorks) {
    //         altsendApplicationerService === 'kontomatik' ? enableKontomatik() : $scope.isWoormyWorks = false;
    //     }
    //     else {
    //         $scope.isWoormyWorks = true;
    //     }
    //     $scope.isSending = false;
    //     $scope.beforeData = false;
    //     $scope.$apply();
    // });
  };

  $scope.getBusinessKey = (key) => {
    $scope.sendXHR({
      url: '/rest/single-application/current-key',
      data: {
        "_id": key
      },
      successFunc: (resp) => {
        $scope.businessKey = resp.data.currentId;
        $scope.loadWoormy();
      }
    });
  }

  $scope.existOfferMess = `<div id="modal-popup">
                              <p class="title text-center">Masz aktualne rzeczywiste oferty od firm pożyczkowych. Wysyłając nową aplikację (wniosek) możesz je stracić.</p>
                              <div class="layout layout-xs-column" layout-align="space-between" layout-align-xs="center center">
                                  <button class="action-btn sa-exist-off" ng-click="sendNewApp()" aria-label="yes">Kontynuować wysyłanie nowego wniosku</button>
                                  <button class="action-btn sa-exist-off" ng-click="goToExistOffer()" aria-label="no">Spójrz na oferty</button>
                              </div>
                            </div>`

  $scope.goToExistOffer = () => {
    $scope.closeDialog();
    $scope.sendAtOnce ? $scope.sendAtOnce = false : "";
    $scope.setClick('.tab--user-offers');
  }

  $scope.sendNewApp = () => {
    $scope.disableSendApp = true;
    $scope.closeDialog();
    !$scope.sendAtOnce ? $scope.preSaveCheck($scope.sendApplication) : $scope.sendApplication();
  }

  $scope.showExistOfferMess = () => {
    $mdDialog.show({
      clickOutsideToClose: false,
      preserveScope: true,
      template: $scope.existOfferMess,
      controller: function () { this.parent = $scope; },
      controllerAs: 'ctrl',
      parent: angular.element(document.body),
      scope: $scope,
    });
    $scope.$watch('$viewContentLoaded', function () {
      let mdDialog = $("#modal-popup").parent();
      mdDialog.css({ "max-width": "570px" });
    })
  }

  $scope.disableSendApp = false;
  $scope.submitFormWithoutVerif = (partners) => {
    $scope.partners = partners;
    if ($scope.allSAOffers.find(x => x.approve === 1)) {
      $scope.showExistOfferMess();
    } else {
      $scope.disableSendApp = true;
      $scope.preSaveCheck($scope.sendApplication)
    }
  }

  $scope.submitFormWithVerif = () => {
    if ($("#singleApp .sa-form-column md-input-container input, md-select").hasClass("ng-dirty")) {
      $scope.preSaveCheck($scope.getVerifStatus)
    } else {
      $scope.getVerifStatus();
    }
  }

  $scope.getVerifStatus = () => {
    $scope.sendXHR({
      url: '/rest/wurmie/wurmie/timer',
      data: { "email": $scope.user.email },
      successFunc: $scope.checkVerifStatus
    });
  }

  $scope.checkVerifStatus = (resp) => {
    if (resp.data.verification) {
      $scope.verificationStatus = true;
      $scope.sendApplication();
    } else if (!resp.data.verification) {
      $scope.verificationStatus = false;
      $scope.failVerification = true;
    }
  }

  $scope.checkParameters = (cost, duration) => {
    (!cost || !duration) ? $scope.isCredytParamsExists = true : "";
  }

  $scope.preSaveCheck = function (successFunction = '') {
    if (($("#singleApp .sa-form-column md-input-container input, md-select").hasClass("ng-dirty"))
      || ($(".sa-header input").hasClass("ng-dirty"))
      || $scope.isCredytParamsExists) {
      $scope.saveApplication(successFunction);
    } else {
      $scope.sendApplication();
    }
  };

  $scope.formUserData = () => {
    let userData = Object.assign({}, $scope.user);
    if (userData.persId2ExpiryDate) {
      userData.persId2ExpiryDate = userData.persId2ExpiryDate.slice(6, 10) + "-" + userData.persId2ExpiryDate.slice(3, 5) + "-" + userData.persId2ExpiryDate.slice(0, 2)
      userData.persId2ExpiryDate = new Date(userData.persId2ExpiryDate).getTime() / 1000;
    }
    (userData.incomeDay && userData.incomeDay[0] === "0") ? userData.incomeDay = userData.incomeDay[1] : "";
    return userData;
  }

  $scope.saveApplication = function (successFunction = $scope.hideLoader) {
    $scope.switchLoader(true, ".loader-fullScreen");
    let userData = $scope.formUserData();
    $.ajax({
      url: '/api/front/application/save-application/save',
      type: 'POST',
      data: userData,
      success: successFunction
    });
  };

  $scope.hideLoader = () => {
    $scope.switchLoader(false, ".loader-fullScreen");
  }

  $scope.sendApplication = async function sendApplication() {
    $scope.switchLoader(true, ".loader-fullScreen");
    if (!$scope.verificationStatus) {
      await $scope.sendAppToOnePartner();
    }
    localStorage.setItem("applicationFirstSent", true);
    $scope.hideLoader();
    location.reload();
  }

  $scope.sentPartNum = 0;
  $scope.sendAppToOnePartner = () => {
    return new Promise((resolve) => {
      for (let i = 0; i < $scope.partners.length; i++) {
        if ($scope.partners[i].wurmie_verification === "0") {
          $.ajax({
            url: '/api/front/application/send-application/send',
            type: 'POST',
            data: {
              email: $scope.user.email,
              partner: $scope.partners[i].partner_id
            },
            success: () => {
              $scope.sentPartNum += 1
              if ($scope.sentPartNum == $scope.partners.length) resolve();
            }
          });
        }
      }
    })
  }

  // second rest to get static offers data
  $scope.getStaticOffers = (partners) => {
    localStorage.getItem("sendAtOnce") ? $scope.sendAtOnce = true : $scope.sendAtOnce = false;
    localStorage.removeItem("sendAtOnce");
    $.ajax({
      url: '/api/front/application/partner-data/data',
      type: 'POST',
      data: {
        email: $scope.user.email,
      },
      success: function success(response) {
        if (response.length) {
          $scope.showCongratsOnAppSent = localStorage.getItem("applicationFirstSent");
          localStorage.removeItem("applicationFirstSent")
          $scope.applicationSent = true;
          $scope.allSAOffers = response;
          $scope.checkOfferStatus(response);
          $scope.checkAvailableOffer();
        } else {
          $scope.applicationSent = false;
          $scope.catchFromRegist(partners);
        }
        $scope.sendAtOnce ? $scope.submitFormWithoutVerif(partners) : ""
      },
    });
  }

  $scope.checkAvailableOffer = () => {
    if (!($scope.allSAOffers.find(x => x.approve === 1))) {
      $scope.availableOffers = false;
    } else {
      $scope.availableOffers = true;
    }
  }

  // third rest to get offers status
  $scope.checkOfferStatus = (resp) => {
    if ($scope.allSAOffers.find(x => x.isset === false)) {
      $scope.offerStatusIsSet = false;
      for (let i = 0; i < resp.length; i++) {
        if (resp[i].isset === false) {
          $scope.idPartner = resp[i].partner;
          $scope.sendXHR({
            url: '/api/front/application/partner-data/loader',
            data: {
              email: $scope.user.email,
              partner: $scope.idPartner
            },
            successFunc: function (resp) {
              $scope.setOffersStatus(resp);
              // $scope.$apply();
            },
            errorFunc: function () {
              $scope.offerStatusError = true;
            }
          });
        }
      }
    } else {
      $scope.offerStatusIsSet = true;
    }
  }

  $scope.setOffersStatus = (resp) => {
    $scope.offerStatusIsSet = false;
    let answeredOffer = $scope.allSAOffers.find(x => x.partner === resp.data.partner);
    answeredOffer.approve = resp.data.approve;
    answeredOffer.error = resp.data.error;
    answeredOffer.url = resp.data.url;
    answeredOffer.businessKey = resp.data.businessKey;
    $scope.checkAvailableOffer();
  }

  $scope.setCalcData = () => {
    sessionStorage.setItem('orangeRange', $scope.user.costVal);
    sessionStorage.setItem('blueRange', $scope.user.durationVal);

    $scope.redirect('/application');
  }

  $scope.inputValCtrl = {
    tel: function () {
      var input = $('input[name="tel"]');
      if (input.val().length >= 1 && input.val()[0] !== '+') input.val('+' + input.val())
    }
  }

  $scope.managePriority = () => {
    const nodesOfOffers = [...document.querySelectorAll('.offer-card')];
    if (nodesOfOffers.length == $scope.allSAOffers.length) {
      nodesOfOffers.forEach((el, i) => {
        $(el).css("order", `${$scope.allSAOffers[i].priority}`)
      }
      )
    }
  }

  $scope.setFirstEntry = (isFirstEntry) => {
    $scope.firstEntry = isFirstEntry;
  }

  $scope.saveProfileForm = () => {
    $scope.saveApplication($scope.setProfileSaveStatus);
  }

  $scope.setProfileSaveStatus = () => {
    $scope.isProfileSaved = true;
    $scope.hideLoader();
  }

  $scope.getActualProfileData = () => {
    $scope.sendXHR({
      url: '/rest/office/user-cancel/execute',
      data: { email: $scope.user.email },
      successFunc: $scope.setInputVal
    });
  }

  $scope.setInputVal = (resp) => {
    let actualData = resp.data;
    var inputs = $('[name="profileForm"] *[name]');
    inputs.each(function () {
      var name = $(this).attr('name');
      if (name.includes("Pr")) {
        let position = name.length - 2;
        name = name.slice(0, position)
      }
      $scope.user[name] = actualData[name];
    });
    $scope.isProfileSaved = true;
  }

  if (document.getElementById("tab--user-profile")) {
    document.getElementById("tab--user-profile").onclick = () => {
      $(window).bind('beforeunload', function () {
        if ($("#profileForm").hasClass("ng-dirty") && !$scope.isProfileSaved) {
          return "Want to leave without saving profile?"
        }
      });
    }
  }

  $scope.catchFromRegist = (partners) => {
    let fromApplication = window.location.href.split('fromApplication=')[1];
    if (fromApplication) {
      $scope.partners = partners;
      $scope.sendApplication();
    }
  }

  $scope.goToAuth = () => {
    $scope.showAuth = true;
  }

  $scope.countOutclick = (partner, businessKey) => {
    let outclickData = {
      "email": $scope.user.email,
      "partner": partner,
      "businessKey": businessKey
    }
    $scope.sendXHR({
      url: '/api/front/application/application-outclick/click',
      data: outclickData,
      successFunc: ""
    });
  }

  $scope.$on('passBanks', function (event, data) {
    $scope.banks = data.banks,
      $scope._banks = Array.from($scope.banks)
  })

  $scope.$on('passUserData', function (event, data) {
    $scope.user = data.user
  })

  $scope.findUserBank = () => {
    let code = $scope.user.bankAccount.slice(2, 6);
    for (let i = 0; i < $scope._banks.length - 1; i++) {
      if (!$scope._banks[i].code.includes(+code)) {
        $scope._banks.splice(i, 1);
        i--;
      }
    }
  }

  $scope.setUserBank = (bankName) => {
    $scope._banks.length > 1 ? $scope._banks.splice($scope._banks.length - 1, 1) : "";
    $scope.user.bankName = bankName;
  }

  $scope.manageUserBankValue = (bankName = '') => {
    $scope._banks = Array.from($scope.banks);
    if ($scope.user.bankAccount) {
      $scope.findUserBank();
      if (bankName) {
        $scope.setUserBank(bankName)
      } else {
        if ($scope._banks.length === 2 && $scope._banks[$scope._banks.length - 1].value === "Konto w innym banku") {
          $scope.setUserBank($scope._banks[0].value)
        } else if ($scope._banks.length > 2) {
          $scope.setUserBank("")
        } else {
          $scope.user.bankName = $scope._banks[0].value
        }
      }
    } else if (!$("input[name='bankAccount']").hasClass("ng-invalid")) {
      $scope.user.bankName = "";
    }
    return $scope.user.bankName;
  }

  $(document).ready(function () {
    $(".check-label").click(function () {
      this.removeAttribute("style")
    });
    $(".regulamin ~ .check-text").click(function () {
      $scope.setClick(".regulamin");
      ($("#regulamin").prop("checked")) ? $scope.user.acceptTerms = true : $scope.user.acceptTerms = false;
    });
    $(".agreement-policy ~ .check-text").click(function () {
      $scope.setClick(".agreement-policy");
      ($("#agreement-policy").prop("checked")) ? $scope.user.acceptAdPolicy = true : $scope.user.acceptAdPolicy = false;
    });
    $(".agreement-data ~ .check-text").click(function () {
      $scope.setClick(".agreement-data");
      ($("#agreement-data").prop("checked")) ? $scope.user.acceptMailingPolicy = true : $scope.user.acceptMailingPolicy = false;
    });

    $('#passExpireDate, #passExpireDatePr').on("paste", function (e) {
      e.preventDefault();
    });
  });

}]);



// WEBPACK FOOTER //
// src/js/controllers/singleApplication/applicationCtrl.js